export const commercialPaperEndpoints = (builder) => ({
    getCommercialPapers: builder.query({
        query: ({ status, offset, limit } = {}) => {
            const params = new URLSearchParams();
            if (status) params.set("status", status);
            if (offset !== undefined && offset !== null) params.set("offset", String(offset));
            if (limit !== undefined && limit !== null) params.set("limit", String(limit));
            const qs = params.toString();
            return { url: `/commercial-papers${qs ? `?${qs}` : ""}`, method: 'get' };
        },
        providesTags: ['Commercial Papers'],
    }),
    getCommercialPaperSubscriptions: builder.query({
        query: ({ status, cpId, userId, offset, limit } = {}) => {
            const params = new URLSearchParams();
            if (status) params.set("status", status);
            if (cpId !== undefined && cpId !== null) params.set("cpId", String(cpId));
            if (userId !== undefined && userId !== null) params.set("userId", String(userId));
            if (offset !== undefined && offset !== null) params.set("offset", String(offset));
            if (limit !== undefined && limit !== null) params.set("limit", String(limit));
            const qs = params.toString();
            return { url: `/commercial-papers/subscriptions${qs ? `?${qs}` : ""}`, method: 'get' };
        },
        providesTags: ['Commercial Papers'],
    }),
    createCommercialPaper: builder.mutation({
        query: (data) => ({ url: `/commercial-papers`, method: 'post', body: data }),
        invalidatesTags: ['Commercial Papers'],
    }),
    updateCommercialPaper: builder.mutation({
        query: ({ cpId, ...data }) => ({ url: `/commercial-papers/${cpId}`, method: 'put', body: data }),
        invalidatesTags: ['Commercial Papers'],
    }),
    deleteCommercialPaper: builder.mutation({
        query: (cpId) => ({ url: `/commercial-papers/${cpId}`, method: 'delete' }),
        invalidatesTags: ['Commercial Papers'],
    }),
    generateCommercialPaperSubscriptionsReportCsv: builder.mutation({
        query: ({ status, cpId, userId } = {}) => {
            const params = new URLSearchParams();
            if (status !== undefined && status !== null) params.set("status", String(status || ""));
            if (cpId !== undefined && cpId !== null) params.set("cpId", String(cpId));
            if (userId !== undefined && userId !== null) params.set("userId", String(userId));
            const qs = params.toString();
            return { url: `/commercial-papers/subscriptions/report/csv${qs ? `?${qs}` : ""}`, method: 'post' };
        },
    }),
    generateCommercialPaperSubscriptionsReportXlsx: builder.mutation({
        query: ({ status, cpId, userId } = {}) => {
            const params = new URLSearchParams();
            if (status !== undefined && status !== null) params.set("status", String(status || ""));
            if (cpId !== undefined && cpId !== null) params.set("cpId", String(cpId));
            if (userId !== undefined && userId !== null) params.set("userId", String(userId));
            const qs = params.toString();
            return { url: `/commercial-papers/subscriptions/report/xlsx${qs ? `?${qs}` : ""}`, method: 'post' };
        },
    }),
    generateCommercialPapersReportCsv: builder.mutation({
        query: ({ status } = {}) => ({ url: `/commercial-papers/report/csv?status=${encodeURIComponent(status || "")}`, method: 'post' }),
    }),
    generateCommercialPapersReportXlsx: builder.mutation({
        query: ({ status } = {}) => ({ url: `/commercial-papers/report/xlsx?status=${encodeURIComponent(status || "")}`, method: 'post' }),
    }),
})
